import API from '../dataApi';

// -- Accounting: Offerings -----------------------------------------------------
export const getOfferings = (params) => API.get('/offerings', { params });
export const createOffering = (data) => API.post('/offerings', data);
export const getOffering = (id) => API.get(`/offerings/${id}`);
export const updateOffering = (id, data) => API.put(`/offerings/${id}`, data);
export const cancelOffering = (id, reason) => API.delete(`/offerings/${id}`, { data: { reason } });
export const purgeOffering = (id) => API.delete(`/offerings/${id}/purge`);
export const reviewOfferingDeleteRequest = (id, action) => API.put(`/offerings/${id}/delete-request`, { action });
export const getPendingOfferings = (derasarId) => API.get('/offerings/pending', { params: { derasarId } });
export const getUserOfferings = (userId, derasarId) => API.get(`/offerings/user/${userId}`, { params: { derasarId } });
